export default "__VITE_ASSET__3QNO5ZhY__"